jQuery(function($) {

	// calculate number of slides in vertical slider based on window height
	let SwiperVertical;
	let $window = $(window);

    function calculate_slides () {
        let WH = $window.height();
		let Slides = 3;
		switch (true) {
			case WH >= 1170 :
				Slides = 9;   // 90 + 120 * 9
				break;
			case WH >= 1050 :
				Slides = 8;   // 90 + 120 * 8
				break;
			case WH >= 930 :
				Slides = 7;   // 90 + 120 * 7
				break;
			case WH >= 810 :
				Slides = 6;   // 90 + 120 * 6
				break;
			case WH >= 690 :
				Slides = 5;   // 90 + 120 * 5
				break;
			case WH >= 570 :
				Slides = 4;   // 90 + 120 * 4
				break;
		}
		return Slides;
	}




	// Slide click fix - prevent triggering clickable elements by swipe
	// https://github.com/kenwheeler/slick/issues/764#issuecomment-306583144
	let Sliding = false;

	// Init swiper
	if ($('[data-swiper]').length > 0) {

		let Swipers = [];

		$('[data-swiper]').each(function (i) {

			let $this = $(this);
			let Data = $this.data('swiper');

			if (Data === 'offcanvas') {

				let Slides = calculate_slides ();
				let Index = $this.find('.swiper').data('index');
				Index = Math.ceil(Index - Slides / 2);
				if (Index < 0) {
					Index = 0;
				}

				SwiperVertical = new Swiper ($this.find('.swiper') [0], {
					navigation: {
						prevEl: `[data-swiper='${Data}'] [data-swipe='up']`,
						nextEl: `[data-swiper='${Data}'] [data-swipe='down']`,
					},
					on: {
						slideChangeTransitionStart: () => { Sliding = true; },
						slideChangeTransitionEnd: () => { Sliding = false; },
					},
					direction: "vertical",
					slidesPerView: Slides,
					initialSlide: Index,
				});

				// https://stackoverflow.com/a/641874
				window.addEventListener('resize', () => {
					let Slides = calculate_slides ();
					SwiperVertical.params.slidesPerView = Slides;
				}, true);

			} else {

				Swipers [i] = new Swiper ($this.find('.swiper') [0], {
					navigation: {
						prevEl: `[data-swiper='${Data}'] [data-swipe='prev']`,
						nextEl: `[data-swiper='${Data}'] [data-swipe='next']`,
					},
					on: {
						slideChangeTransitionStart: () => { Sliding = true; },
						slideChangeTransitionEnd: () => { Sliding = false; },
					},
					breakpoints: {
						0:    { spaceBetween: 10, slidesPerView: 2 },
						577:  { spaceBetween: 15, slidesPerView: 2 },
						769:  { spaceBetween: 20, slidesPerView: 3 },
						993:  { spaceBetween: 30, slidesPerView: 4 },
						1351: { spaceBetween: 30, slidesPerView: 5 },
						1801: { spaceBetween: 44, slidesPerView: 6 },
					},
					centeredSlidesBounds: true,
				});

			}

		});

	}



	// Select dropdown active class - when FacetWP is ready
	// https://facetwp.com/help-center/developers/javascript-reference/facetwp-loaded/
	document.addEventListener('facetwp-loaded', () => {
		$('.facetwp-dropdown').on('click', function () {
			let $this = $(this);
			if ($this.hasClass)
			$('.facetwp-dropdown')
			$(this).toggleClass('active');
		});
	});



});
